export default class UnitemizedAmounts {
  public static readonly STATUTORY_COUNTY_CENTRAL_COMMITTEE_UNITEMIZED_AMOUNT = 50;
  public static readonly STATE_PARTY_UNITEMIZED_AMOUNT = 200;
  public static readonly ALL_OTHER_UNITEMIZED_AMOUNT = 25;
}
